<template lang="pug">
  v-row
    v-container
      v-row.mt-3
        h1(strong) Bienvenido
      v-row(cols='12')
        v-col(sm='12' md='8')
          v-container
            v-row          
              template(v-for='item in partidas_cartas')
                v-col(xs='12' sm='4' md='4')
                  v-card(hover height='100%')
                    v-card-title
                      h2.text-left  S/ {{(item.saldo[periodo_actual]) ? (item.saldo[periodo_actual].saldo) : 0}}
                      span(v-if='item.acumulado')
                        acumulado(:objeto='{saldo: (item.saldo) ? item.saldo : 0, acumulado: (item.acumulado) ? item.acumulado : false}')
                    v-card-text {{item.descripcion}}
            v-row
              template(v-for='item in partidas_histograma')
                v-col(xs='12' sm='6' md='6')
                  v-card(elevation=3)
                    v-card-title.mb-0  
                    histograma(:objeto='item')
        v-col(sm='12' md='4')
          Lista_de_documentos
          


</template>
<script>
import { mapGetters, mapActions, mapMutations,mapState } from 'vuex'
import {coleccion_partidas_contables} from '@/FirebaseConfig'
import {secondsToFullTimestamp, obtener_periodo, toNumber} from '@/Helper.js'
import LineChart from  '../../../store/components/LineChart.js'
import acumuladoVue from '../componentes/acumulado.vue'
export default {
    data: ()=>({
        periodo_actual: obtener_periodo()
    }),
    computed: {
        ...mapGetters({
            partidas_cartas: 'Partidas_Contables/registro_cartas',
            partidas_histograma: 'Partidas_Contables/registro_histograma',
            partidas_acumuladas: 'Partidas_Contables/registro_acumulado'
        })
    },
    components: {
        histograma: ()=>import('../componentes/histograma'),
        acumulado: ()=>import('../componentes/acumulado'),
        Lista_de_documentos: ()=>import('../componentes/lista_de_documentos')
    }
}
</script>